import React, { useEffect, useState } from "react";
import { Modal, Form, Row, Col, Button, Alert } from "react-bootstrap";
import { jwtDecode } from "jwt-decode";
import {
  getPatientById,
  getPracticeById,
  getServiceById,
  getPracticesByNumbers,
  getServicesByPracticeNumbers,
  getAccountByPatientId,
  getAccountPatients,
  fetchallUsersByPractices,
  getAppointmentsByPatientId,
} from "../../api";
import SearchICD10 from "../SearchICD10/SearchICD10";
import { fetchAllmsrRates } from "../../medPracapi";
import { createInvoice, getPlacesOfService } from "../../afinanceapi";
import TariffSearch from "../Services/searchTariffs";
import { FaCheck, FaTimes } from "react-icons/fa";
import "../Accounts/CreateInvoice.css";
import { useNavigate } from "react-router-dom";

function CompleteAppointmentModal({
  props,
  appointment,
  handleClose,
  onHide,
  onComplete,
}) {
  const [show, setShow] = useState(true);
  const [closeAlert, setCloseAlert] = useState(false);
  const [successAlert, setSuccessAlert] = useState(false);
  const [patient, setPatient] = useState(null);
  const [patients, setPatients] = useState([]);
  const [practice, setPractice] = useState(null);
  const [service, setService] = useState(null);
  const [userPractices, setUserPractices] = useState([]);
  const [selectedPractice, setSelectedPractice] = useState(
    appointment.practiceId
  );
  const [selectedService, setSelectedService] = useState("");
  const [practiceServices, setPracticeServices] = useState([]);
  const [services, setServices] = useState([]);
  const [selectedICD10s, setSelectedICD10s] = useState([]);
  const [account, setAccount] = useState({});
  const [completionErrors, setCompletionErrors] = useState({});
  const [selectedPractitionerId, setSelectedPractitionerId] = useState("");
  const [selectedPlaceOfService, setSelectedPlaceOfService] = useState("");
  const [practitioners, setPractitioners] = useState([]);
  const [placesOfService, setPlacesOfService] = useState([]);
  const [lines, setLines] = useState([]);
  const [lineErrors, setLineErrors] = useState({});
  const [lineAppointments, setLineAppointments] = useState({});
  const [invoice, setInvoice] = useState({});
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [invoiceNumber, setInvoiceNumber] = useState("");
  const [invoiceStatus, setInvoiceStatus] = useState("");
  const [userRole, setUserRole] = useState("");

  const navigate = useNavigate();

  useEffect(() => {
    async function fetchData() {
      try {
        const placesOfServiceData = await getPlacesOfService();
        setPlacesOfService(placesOfServiceData);
        console.log("Places of Service:", placesOfServiceData);
        const token = sessionStorage.getItem("user");
        const user = jwtDecode(token);
        setInvoice((prev) => ({ ...prev, invoiceCreatedBy: user._id }));
        setUserRole(user.role);

        const patientData = await getPatientById(appointment.patientId);
        setPatient(patientData);

        const accountData = await getAccountByPatientId(appointment.patientId);
        setAccount(accountData);

        const patientsData = await getAccountPatients(accountData._id);
        setPatients(patientsData);

        const practiceData = await getPracticeById(appointment.practiceId);
        setPractice(practiceData);
        setSelectedPractice(appointment.practiceId);
        console.log("Selected PracticeNum!!:", practiceData.practiceNumber);
        console.log("Selected Practice!!:", practiceData);

        const userPractice = await getPracticesByNumbers(user.practice);
        setUserPractices(userPractice);
        console.log("User Practices:", userPractice);

        const serviceData = await getServiceById(appointment.serviceId);
        setService(serviceData);
        setSelectedService(serviceData._id);
        console.log("Selected Service:", serviceData);

        const allServices = await getServicesByPracticeNumbers(user.practice);
        setPracticeServices(allServices);
        setServices(allServices);
        console.log("All Services:", allServices);

        setSelectedPractitionerId(appointment.resourceId);

        

        console.log("Places of Service:", placesOfServiceData);

        // ✅ Generate all lines directly
        const generatedLines = await generateServiceLinesFromService(
          serviceData,
          patientData._id,
          patientData.patientMedicalAid,
          patientData.patientMedicalAidOptionCode,
          appointment._id,
          appointment.practiceId
        );
        setLines(generatedLines);
        console.log("Generated Lines:", generatedLines);
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    }
    fetchData();
  }, [appointment, onComplete]);

  useEffect(() => {
    if (!selectedICD10s.length) return;
    setLines((lines) =>
      lines.map((line) => ({
        ...line,
        icd101: line.icd101 || selectedICD10s[0].ICD10_Code,
        icd102: line.icd102 || "",
      }))
    );
  }, [selectedICD10s]);

  useEffect(() => {
    if (!selectedPlaceOfService && placesOfService.length > 0) {
      setSelectedPlaceOfService(placesOfService[0].HCFA_code);
    }
  }, [placesOfService, selectedPlaceOfService]);

  const generateServiceLinesFromService = async (
    service,
    patientId,
    patientMedicalAid,
    patientMedicalAidOptionCode,
    appointmentId,
    selectedPractice
  ) => {
    const tariffs = service.pricing?.selectedTariffs || [];
    const useFlatRate = service.pricing?.paymentOptions?.useFlatRate;
    const useFlatAndMedicalAidRate =
      service.pricing?.paymentOptions?.useFlatAndMedicalAidRate;

    const fallbackDescription = service.pricing?.invoiceDescription || "";
    const fallbackFlatRateString = service.pricing?.flatRate || "R 0";
    const fallbackFlatRate =
      parseFloat(fallbackFlatRateString.replace(/[^\d.]/g, "")) || 0;

    const isMedicalAid = patientMedicalAid !== "";

    const baseLineInfo = {
      patientId,
      appointmentId,
      appointmentDateSet: new Date(appointment.start)
        .toISOString()
        .split("T")[0],
      useCustomDate: false,
      icd101: selectedICD10s[0]?.ICD10_Code || "",
      icd102: "",
      serviceId: service._id,
      selectedService: service,
      type: "service",
    };

    let lines = [];

    if (!isMedicalAid || (useFlatRate && tariffs.length === 0)) {
      // Private or fallback flat rate
      lines.push({
        ...baseLineInfo,
        tariffCode: "",
        description: fallbackDescription,
        quantity: 1,
        rate: fallbackFlatRate,
        lineNumber: 1,
      });
    } else {
      lines = await Promise.all(
        tariffs.map(async (tariff, i) => {
          let quantity = tariff.qty || 1;
          let rate = 0;
          let description = tariff.description || fallbackDescription;

          if (useFlatAndMedicalAidRate) {
            const msr = await getMSRRate(
              selectedPractice,
              tariff.code,
              patientMedicalAidOptionCode
            );
            rate = msr.rate;
            quantity = msr.quantity;
          } else if (useFlatRate) {
            rate = parseFloat(tariff.rate || "0");
          }

          return {
            ...baseLineInfo,
            tariffCode: tariff.code || "",
            description,
            quantity,
            rate,
            lineNumber: i + 1,
          };
        })
      );
    }

    return lines;
  };

  useEffect(() => {
    if (selectedPractice) {
      async function getPractitioners() {
        const data = await fetchallUsersByPractices([selectedPractice]);
        setPractitioners(data);
      }
      getPractitioners();
    }
  }, [selectedPractice]);

  const selectedPractitioner = practitioners.find(
    (p) => p.id === selectedPractitionerId
  );

  const handleICD10Select = (ICD10) => {
    if (
      ICD10 &&
      !selectedICD10s.some((item) => item.ICD10_Code === ICD10.ICD10_Code)
    ) {
      setSelectedICD10s((prev) => [...prev, ICD10]);
    }
  };

  const validateCompletionFields = () => {
    const newErrors = {};

    if (!selectedPractice) newErrors.practice = "Practice is required.";
    if (!selectedPractitionerId)
      newErrors.practitioner = "Practitioner is required.";
    if (account.accountMedicalAid && selectedICD10s.length === 0) {
      newErrors.icd10 =
        "At least one ICD10 code is required for medical aid patients.";
    }
    setCompletionErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleAddLine = async () => {
    if (!validateCompletionFields()) return;

    const formattedDate = new Date(appointment.start)
      .toISOString()
      .split("T")[0];

    const base = {
      lineNumber: lines.length + 1, // ← add
      patientId: patient._id, // ← add (if not already there)
      appointmentId: appointment._id,
      appointmentDateSet: formattedDate, // ← add
      appointmentDateCustom: null, // ← add (null unless useCustomDate)
      useCustomDate: false,
      icd101:
        selectedICD10s[0]?.ICD10_Code || selectedICD10s[0].ICD10_3_Code || "",
      icd102: "", // ← add
      tariffCode: "",
      description: "",
      quantity: 1,
      rate: 0,
      privatePayment: false,
      type: "custom",
    };

    setLines((prev) => [...prev, base]);
  };

  const handleAddServiceLine = async () => {
    if (!validateCompletionFields()) return;
    const formattedDate = new Date(appointment.start)
      .toISOString()
      .split("T")[0];

    const base = {
      lineNumber: lines.length + 1, // ← add
      patientId: patient._id, // ← add (if not already there)
      appointmentId: appointment._id,
      appointmentDateSet: formattedDate, // ← add
      icd101:
        selectedICD10s[0]?.ICD10_Code || selectedICD10s[0].ICD10_3_Code || "",
      icd102: "", // ← add
      tariffCode: "",
      description: "",
      quantity: 1,
      rate: 0,
      privatePayment: false,
      type: "custom",
    };

    setLines((prev) => [...prev, { ...base, type: "service" }]);
  };

  const handleAddTariffLine = async () => {
    if (!validateCompletionFields()) return;
    const formattedDate = new Date(appointment.start)
      .toISOString()
      .split("T")[0];

    const base = {
      lineNumber: lines.length + 1, // ← add
      patientId: patient._id, // ← add (if not already there)
      appointmentId: appointment._id,
      appointmentDateSet: formattedDate, // ← add
      appointmentDateCustom: null, // ← add (null unless useCustomDate)
      useCustomDate: false,
      icd101:
        selectedICD10s[0]?.ICD10_Code || selectedICD10s[0].ICD10_3_Code || "",
      icd102: "", // ← add
      tariffCode: "",
      description: "",
      quantity: 1,
      rate: 0,
      privatePayment: false,
      type: "custom",
    };

    setLines((prev) => [...prev, { ...base, type: "tariff" }]);
  };

  const handleLineChange = async (index, field, value) => {
    const updatedLines = [...lines];
    const currentLine = updatedLines[index];
    const formattedDate = new Date(appointment.start)
      .toISOString()
      .split("T")[0];

    if (field === "patientId") {
      const patientId = value;
      const selectedPatient = patients.find((p) => p._id === patientId);

      let appointments = lineAppointments[patientId];

      if (!appointments) {
        appointments = await getAppointmentsByPatientId(patientId);
        setLineAppointments((prev) => ({
          ...prev,
          [patientId]: appointments,
        }));
      }

      const firstAppointmentId = appointments[0]?._id || "";

      updatedLines[index] = {
        ...currentLine,
        patientId,
        appointmentId: firstAppointmentId,
        appointmentDateSet: formattedDate,
        patientFullNames: selectedPatient?.patientFirstName || "",
        patientLastName: selectedPatient?.patientLastName || "",
      };
    } else {
      updatedLines[index] = {
        ...currentLine,
        [field]: value,
      };
    }
    setLines(updatedLines);
  };

  async function getMSRRate(practiceNumber, tariffCode, planOptionCode) {
    const rateData = await fetchAllmsrRates(
      practiceNumber,
      [tariffCode],
      planOptionCode
    );
    const msrEntry = rateData.find((entry) => entry.priceGroupType === "MSR");
    console.log("MSR Entry:", msrEntry);
    let rate = 0;
    let quantity = 1;

    if (msrEntry) {
      quantity = msrEntry.numberOfUnits || 1;

      if (
        msrEntry?.tariffRandSchemeFixed &&
        msrEntry.tariffRandSchemeFixed > 0
      ) {
        rate = msrEntry.tariffRandSchemeFixed;
      } else if (
        msrEntry?.tariffRandRcfSchemeRate &&
        msrEntry.tariffRandRcfSchemeRate > 0
      ) {
        rate = msrEntry.tariffRandRcfSchemeRate;
      } else if (
        msrEntry?.tariffRandCalculated &&
        msrEntry.tariffRandCalculated > 0
      ) {
        rate = msrEntry.tariffRandCalculated;
      }
    }
    console.log("MSR Rate:", rate, "Quantity:", quantity);
    return { rate: parseFloat(rate.toFixed(2)), quantity };
  }

  const handleServiceSelect = async (index, serviceId) => {
    const selectedService = services.find((s) => s._id === serviceId);
    if (!selectedService) return;
    const formattedDate = new Date(appointment.start)
      .toISOString()
      .split("T")[0];
    const tariffs = selectedService.pricing?.selectedTariffs || [];
    const useFlatRate = selectedService.pricing?.paymentOptions?.useFlatRate;
    const useFlatAndMedicalAidRate =
      selectedService.pricing?.paymentOptions?.useFlatAndMedicalAidRate;

    const fallbackDescription =
      selectedService.pricing?.invoiceDescription || "";
    const fallbackFlatRateString = selectedService.pricing?.flatRate || "R 0";
    const fallbackFlatRate =
      parseFloat(fallbackFlatRateString.replace(/[^\d.]/g, "")) || 0;

    const originalLine = lines[index] || {};
    const isMedicalAid =
      account?.accountMedicalAid && account.accountMedicalAid !== "";

    const baseLineInfo = {
      lineNumber: originalLine.lineNumber ?? index + 1,
      patientId: originalLine.patientId || "",
      appointmentId: originalLine.appointmentId || "",
      appointmentDateset: formattedDate || "", // ✅ Preserved
      icd101:
        originalLine.icd101 ||
        selectedICD10s[0]?.ICD10_Code ||
        selectedICD10s[0].ICD10_3_Code ||
        "",
      icd102: originalLine.icd102 || "",
      serviceId,
      selectedService,
      type: "service",
    };

    let newServiceLines = [];

    if (!isMedicalAid || (useFlatRate && tariffs.length === 0)) {
      // ✅ Private patient – single line with fallback data
      newServiceLines.push({
        ...baseLineInfo,
        tariffCode: "",
        description: fallbackDescription,
        quantity: 1,
        rate: fallbackFlatRate,
      });
    } else {
      // ✅ Medical Aid patients with tariffs – map over tariffs
      newServiceLines = await Promise.all(
        tariffs.map(async (tariff) => {
          let quantity = tariff.qty || 1;
          let rate = 0;
          let description = tariff.description || fallbackDescription;

          if (useFlatAndMedicalAidRate) {
            const msr = await getMSRRate(
              practice.practiceNumber, // This should be just the practiceNumber
              tariff.code,
              account.accountMedicalAidOptionCode
            );
            rate = msr.rate;
            quantity = msr.quantity;
          } else if (useFlatRate) {
            rate = parseFloat(tariff.rate || "0.00");
          }

          return {
            ...baseLineInfo,
            appointmentDateSet: formattedDate,
            tariffCode: tariff.code || "",
            description,
            quantity,
            rate,
          };
        })
      );
    }

    // ✅ Replace the original line with the new one(s)
    const updatedLines = [...lines];
    updatedLines.splice(index, 1, ...newServiceLines);
    setLines(updatedLines);
  };

  async function handleTariffLineSelect(index, tariff) {
    const formattedDate = new Date(appointment.start)
      .toISOString()
      .split("T")[0];
    const tariffCode = tariff.code;

    const { rate, quantity } = await getMSRRate(
      practice.practiceNumber,
      tariffCode,
      account.accountMedicalAidOptionCode
    );

    const updated = [...lines];
    updated[index] = {
      ...updated[index],
      appointmentDateSet: formattedDate,
      selectedTariff: tariff,
      tariffCode: tariffCode,
      description: `${tariff.description} (${tariff.typeCode})`,
      quantity,
      rate,
    };

    setLines(updated);
  }

  const handleRemoveLine = (index) => {
    const updatedLines = lines.filter((_, i) => i !== index);
    setLines(updatedLines);
  };

  const totalPatientAmount = lines.reduce((total, line) => {
    if (!line.tariffCode || line.privatePayment) {
      const rate = parseFloat(line.rate) || 0;
      return total + rate;
    }
    return total;
  }, 0);

  const totalMedicalAidAmount = lines.reduce((total, line) => {
    if (line.tariffCode && !line.privatePayment) {
      const rate = parseFloat(line.rate) || 0;
      return total + rate;
    }
    return total;
  }, 0);

  const totalAmount = lines.reduce((total, line) => {
    const rate = parseFloat(line.rate) || 0;
    return total + rate;
  }, 0);

  const constructInvoice = () => {
    // today's date in YYYY-MM-DD
    const today = new Date().toISOString().split("T")[0];
    const formattedDate = new Date(appointment.start)
      .toISOString()
      .split("T")[0];

    // build the line items array
    const invoiceLines = lines.map((line) => ({
      lineNumber: line.lineNumber,
      type: line.type,
      serviceId: line.serviceId || null,
      selectedService: line.selectedService || null,
      selectedTariff: line.selectedTariff || null,
      icd101:
        line.icd101 ||
        selectedICD10s[0]?.ICD10_Code ||
        selectedICD10s[0]?.ICD10_3_Code ||
        "",
      icd102: line.icd102 || "",
      tariffCode: line.tariffCode,
      description: line.description,
      quantity: line.quantity,
      rate: parseFloat(line.rate || 0),
      privatePayment: line.privatePayment || false,
      appointmentId: line.useCustomDate ? null : line.appointmentId,
      appointmentDateSet: formattedDate || null,
    }));

    // assemble the full invoice object
    const newInvoice = {
      accountId: account._id,
      accountName: `${account.accountFullNames} ${account.accountLastName}`,
      accountEmail: account.accountEmail,
      medicalAid: {
        name: account.accountMedicalAid,
        plan: account.accountMedicalAidPlan,
        option: account.accountMedicalAidOption,
        number: account.accountMedicalAidNumber,
        optionCode: account.accountMedicalAidOptionCode,
      },
      practice: practice
        ? {
            practiceNumber: practice.practiceNumber,
            practiceName: practice.practiceName,
            vatNumber: practice.vatNumber,
          }
        : null,
      practitioner: selectedPractitioner
        ? {
            id: selectedPractitioner.id,
            firstName: selectedPractitioner.firstName,
            lastName: selectedPractitioner.lastName,
            hpcsa: selectedPractitioner.hpcsa,
          }
        : null,
      invoiceNumber: invoiceNumber || null,
      invoiceDate: today,
      totalAmount,
      totalMedicalAidAmount,
      totalPatientAmount,
      placeOfService: selectedPlaceOfService,
      icd10Codes: selectedICD10s.map((icd) => ({
        ICD10_Code: icd.ICD10_Code,
        ICD10_3_Code: icd.ICD10_3_Code,
        ICD10_3_Description: icd.ICD10_3_Description,
        ICD10_Description: icd.ICD10_Description,
      })),
      patient: {
        patientId: patient._id,
        patientFirstName: patient.patientFirstName,
        patientLastName: patient.patientLastName,
        patientMedicalAid: patient.patientMedicalAid,
        patientMedicalAidNumber: patient.patientMedicalAidNumber,
        patientMedicalAidOptionCode: patient.patientMedicalAidOptionCode,
        patientMedicalAidPlanCode: patient.patientMedicalAidPlanCode,
        patientMedicalAidDependantCode: patient.patientMedicalAidDependantCode,
      },
      lines: invoiceLines,
      // note: status is assigned later (handleSubmit/handlePost)
    };

    // keep local state in sync
    setInvoice(newInvoice);

    return newInvoice;
  };

  const validateCompletionLines = () => {
    const errors = {};
    let hasError = false;

    if (lines.length === 0) {
      alert("At least one invoice line is required.");
      return false;
    }

    lines.forEach((line, idx) => {
      const lineError = {};

      if (!line.useCustomDate && !line.appointmentId) {
        lineError.appointmentId = "Appointment is required.";
      }

      if (line.useCustomDate && !line.appointmentDate) {
        lineError.appointmentDate = "Custom date is required.";
      }

      if (account.accountMedicalAid && !line.icd101) {
        if (selectedICD10s.length > 0) {
          line.icd101 = selectedICD10s[0].ICD101_Code;
        } else {
          lineError.icd101 = "ICD10 code is required.";
        }
      }

      if (!line.description) {
        lineError.description = "Description is required.";
      }

      if (!line.quantity || Number(line.quantity) <= 0) {
        lineError.quantity = "Quantity must be greater than 0.";
      }

      if (!line.rate || Number(line.rate) <= 0) {
        lineError.rate = "Rate must be greater than 0.";
      }

      if (!selectedPlaceOfService) {
        lineError.placeOfService = "Place of Service is required.";
      }

      if (Object.keys(lineError).length > 0) {
        errors[idx] = lineError;
        hasError = true;
      }
    });

    setLineErrors(errors);
    return !hasError;
  };

  const handleSubmit = async () => {
    if (isSubmitting) return;

    setIsSubmitting(true);

    const isHeaderValid = validateCompletionFields();
    const isLinesValid = validateCompletionLines();

    if (!isHeaderValid || !isLinesValid) {
      setIsSubmitting(false);
      return;
    }

    try {
      const invoiceToSave = constructInvoice();
      const response = await createInvoice(invoiceToSave);
      const newNumber =
        response.invoiceNumber ?? response.invoice?.invoiceNumber;
      const newStatus = response.status ?? response.invoice?.status;

      setInvoiceNumber(newNumber);
      setInvoiceStatus(newStatus || "Pending");

      onComplete(true);

      // Wait a bit to show the success alert before closing/navigating
      setTimeout(() => {
        onHide();
        navigate(`/patients/appointment/${appointment.patientId}/${appointment._id}`);
        setCloseAlert(false);
      }, 2000); // Wait 2 seconds before navigating
    } catch (error) {
      console.error("❌ Error saving/updating invoice:", error);
    } finally {
      setIsSubmitting(false);
    }
  };

  function handleClose() {
    setCloseAlert(true); // Show confirmation alert
    setSuccessAlert(false); // Hide success alert if open
  }

  const handleCancelNo = () => {
    setCloseAlert(false); // Hide alert and keep modal open
  };

  const handleCancelYes = () => {
    setCloseAlert(false); // Hide alert first
    onComplete(false); // Reset completion state
    setInvoice({});
    onHide(); // Close modal
    setCloseAlert(false);
  };

  const handlePost = async () => {
    if (isSubmitting) return;
    setIsSubmitting(true);

    const isHeaderValid = validateCompletionFields();
    const isLinesValid = validateCompletionLines();
    if (!isHeaderValid || !isLinesValid) {
      setIsSubmitting(false);
      return;
    }

    try {
      // build the base invoice
      const invoiceToSave = constructInvoice();

      // determine the posted status
      const hasMedicalAid =
        !!invoiceToSave.medicalAid?.name &&
        invoiceToSave.lines.some((line) => !line.privatePayment);

      invoiceToSave.status = hasMedicalAid
        ? "Posted - Claim in Progress"
        : "Posted";

      // send it up
      console.log("invoiceToSave:", invoiceToSave);
      const response = await createInvoice(invoiceToSave);
      const created = response.invoice || response;

      // update local UI state
      setInvoiceNumber(created.invoiceNumber);
      setInvoiceStatus(created.status);
console.log("created:", created);
      onComplete(true);
      // show success, then navigate
      setSuccessAlert(true);
      window.scrollTo({ top: 0, behavior: "smooth" });
      setTimeout(() => {
        setSuccessAlert(false);
        navigate(`/invoices/posted/${created.invoiceId}`);
      }, 3000);
    } catch (error) {
      console.error("❌ Error posting invoice:", error);
    } finally {
      setIsSubmitting(false);
    }
  };

  const isCompleted = appointment.status === "Completed";

  return (
    <>
      <Modal
        show={show} // <- This should persist across re-renders
        onHide={handleClose}
        centered
        dialogClassName="modal-85w"
      >
        <Modal.Header
          closeButton={!closeAlert && !successAlert}
          className="border-secondary"
        >
          <div className="w-100">
            <Modal.Title className="text-primary">
              Complete Appointment
            </Modal.Title>

            {closeAlert && (
              <Alert
                variant="info"
                className="d-flex justify-content-between mt-3"
              >
                <span>
                  Are you sure you want to close? The entered data will be
                  removed.
                </span>
                <div>
                  <Button
                    variant="outline-primary"
                    className="me-1"
                    onClick={handleCancelYes}
                  >
                    <FaCheck />
                  </Button>
                  <Button
                    variant="outline-secondary"
                    className="me-1"
                    onClick={handleCancelNo}
                  >
                    <FaTimes />
                  </Button>
                </div>
              </Alert>
            )}
            {successAlert && (
              <Alert
                variant="success"
                className="d-flex justify-content-between mt-3"
              >
                <span>
                  The appointment was closed successfully and the invoice was
                  created in a pending state.
                </span>
              </Alert>
            )}
          </div>
        </Modal.Header>
        <Modal.Body>
          <Form>
            <Row className="mb-3">
              {/* Patient Info */}
              <Col md={3}>
                <h6 className="text-primary">Patient</h6>
                <p className="fw-bold mb-0">
                  {patient?.patientTitle} {patient?.patientFullNames}{" "}
                  {patient?.patientLastName}
                </p>
                <p>
                  <i className="fa-regular fa-hashtag me-2 text-primary"></i>
                  {patient?.patientNumber}
                </p>
                <div className="mt-3">
                  <p className="mb-0 fw-bold">Medical Aid:</p>
                  <p className="ms-2 mb-0">{patient?.patientMedicalAid}</p>
                  <p className="ms-2 mb-0">
                    {patient?.patientMedicalAidPlan} |{" "}
                    {patient?.patientMedicalAidOption}
                  </p>
                  <p className="ms-2 mb-0">
                    {patient?.patientMedicalAidNumber}
                  </p>
                  <p className="ms-2 mb-0">
                    Dep: ({patient?.patientMedicalAidDependantCode})
                  </p>
                </div>
              </Col>

              {/* Account Info + ICD10 */}
              <Col md={4}>
                <h6 className="text-primary">Account</h6>
                <p className="fw-bold mb-0">
                  {account?.accountTitle} {account?.accountFullNames}{" "}
                  {account?.accountLastName}
                </p>
                <p className="ms-3 mb-0">{account?.accountHomeAddress1}</p>
                <p className="ms-3 mb-1">
                  {account?.accountHomeAddress2} {account?.accountHomeAddressCity}
                  , {account?.accountHomeAddressPostalCode}
                </p>
                <p className="ms-3 mb-0">{account?.accountTelNumberCell}</p>
                <p className="ms-3 mb-2">{account?.accountEmail}</p>

                <Form.Group>
                  <Form.Label className="fw-bold mt-2">
                    Select ICD10(s)
                  </Form.Label>
                  <SearchICD10 onICD10Select={handleICD10Select} />
                  {completionErrors.icd10 && (
                    <div className="text-danger mt-1">
                      {completionErrors.icd10}
                    </div>
                  )}
                </Form.Group>

                {selectedICD10s.length > 0 && (
                  <ul className="mt-2">
                    {selectedICD10s.map((icd, idx) => (
                      <li key={idx} className="text-primary">
                        {icd.ICD10_3_Code} - {icd.ICD10_3_Description} |{" "}
                        {icd.ICD10_Code} - {icd.ICD10_Description}
                      </li>
                    ))}
                  </ul>
                )}
              </Col>

              {/* Practice & Practitioner Info */}
              <Col md={3}>
                <Form.Group className="mb-3">
                  <Form.Label className="fw-bold">Select Practice</Form.Label>
                  <Form.Select
                    className="w-100"
                    value={selectedPractice || ""}
                    onChange={(e) => setSelectedPractice(e.target.value)}
                    isInvalid={!!completionErrors.practice}
                    disabled={isCompleted}
                    style={isCompleted ? { backgroundColor: "#e9ecef" } : {}}
                  >
                    <option value="">Select a practice...</option>
                    {userPractices.map((p) => (
                      <option key={p.practiceNumber} value={p.practiceNumber}>
                        {p.practiceName}
                      </option>
                    ))}
                  </Form.Select>

                  <Form.Control.Feedback type="invalid">
                    {completionErrors.practice}
                  </Form.Control.Feedback>
                </Form.Group>

                <Form.Group className="mb-3">
                  <Form.Label className="fw-bold">
                    Select Practitioner
                  </Form.Label>
                  <Form.Select
                    className="w-100"
                    value={selectedPractitionerId}
                    onChange={(e) => setSelectedPractitionerId(e.target.value)}
                    isInvalid={!!completionErrors.practitioner}
                    disabled={isCompleted}
                    style={isCompleted ? { backgroundColor: "#e9ecef" } : {}}
                  >
                    <option value="">Select a practitioner...</option>
                    {practitioners.map((practitioner) => (
                      <option key={practitioner.id} value={practitioner.id}>
                        {practitioner.firstName} {practitioner.lastName}
                      </option>
                    ))}
                  </Form.Select>
                  <Form.Control.Feedback type="invalid">
                    {completionErrors.practitioner}
                  </Form.Control.Feedback>
                </Form.Group>

                <Form.Group className="mb-1">
                  <Form.Label className="fw-bold">Place of Service</Form.Label>
                  <Form.Select
                    className="w-100"
                    value={selectedPlaceOfService}
                    onChange={(e) => setSelectedPlaceOfService(e.target.value)}
                    isInvalid={!!completionErrors.placeOfService}
                    disabled={isCompleted}
                    style={isCompleted ? { backgroundColor: "#e9ecef" } : {}}
                  >
                    {placesOfService.map((pos) => (
                      <option key={pos.HCFA_code} value={pos.HCFA_code}>
                        {pos.HCFA_code} - {pos.newDescription}
                      </option>
                    ))}
                  </Form.Select>
                  <Form.Control.Feedback type="invalid">
                    {completionErrors.placeOfService}
                  </Form.Control.Feedback>
                </Form.Group>
              </Col>
            </Row>

            <hr />
            <Col md={6}>
              <div className="d-flex gap-2 mt-2 mb-3">
                <Button
                  variant="outline-primary"
                  onClick={handleAddLine}
                  className="w-25"
                  disabled={isCompleted}
                >
                  + Line
                </Button>
                <Button
                  variant="outline-primary"
                  onClick={handleAddServiceLine}
                  className="w-25"
                  disabled={isCompleted}
                >
                  + Service
                </Button>
                <Button
                  variant="outline-primary"
                  className="w-25"
                  onClick={handleAddTariffLine}
                  disabled={isCompleted}
                >
                  + Tariff
                </Button>
              </div>
            </Col>
            <Row className="fw-normal text-primary mb-2">
              <Col md={2} className="text-center">
                Appointment | Date
              </Col>
              <Col md={1} className="text-center">
                Prim ICD10
              </Col>
              <Col md={1} className="text-center">
                Sec ICD10
              </Col>
              <Col md={1} className="text-center">
                Tariff | Modifier
              </Col>
              <Col md={3} className="text-center">
                Description
              </Col>
              <Col md={1} className="text-center">
                Qty
              </Col>
              <Col md={1} className="text-center">
                Rate
              </Col>
              <Col md={1} className="text-center">
                Private
              </Col>
              <Col md={1} className="text-center"></Col>
            </Row>

            {/* Invoice Lines */}
            {lines.map((line, index) => (
              <div key={index}>
                {line.type === "tariff" && !line.selectedTariff && (
                  <Col md={4} className="mt-2 mb-2">
                    <TariffSearch
                      practiceNumber={practice.practiceNumber}
                      onTariffCodeSelect={(tariff) =>
                        handleTariffLineSelect(index, tariff)
                      }
                    />
                  </Col>
                )}

                {/* Service selection dropdown (only visible if type is service and no selectedService yet) */}
                {line.type === "service" && !line.selectedService && (
                  <Row className="mb-2">
                    <Col md={4}>
                      <Form.Select
                        value={line.serviceId}
                        onChange={(e) =>
                          handleServiceSelect(index, e.target.value)
                        }
                      >
                        <option value="">Select service</option>
                        {services.map((s) => (
                          <option key={s._id} value={s._id}>
                            {s.servicesName}
                          </option>
                        ))}
                      </Form.Select>
                    </Col>
                  </Row>
                )}

                {/* Show line fields only if not a service OR a service has been selected */}
                {(line.type === "custom" ||
                  line.selectedService ||
                  line.selectedTariff) && (
                  <Row className="align-items-center mb-2">
                    <Col md={2}>
                      <div className="d-flex align-items-center gap-2">
                        {/* Toggle Icons */}
                        <Form.Control
                          type="date"
                          className="flex-grow-1"
                          name="appointmentDateSet"
                          value={line.appointmentDateSet || ""}
                          readOnly
                          disabled
                          style={{ backgroundColor: "#e9ecef" }}
                        />
                      </div>
                    </Col>

                    <Col md={1}>
                      {selectedICD10s.length > 0 &&
                        (() => {
                          const defaultCode =
                            selectedICD10s[0].ICD10_Code ||
                            selectedICD10s[0].ICD10_3_Code;

                          return (
                            <Form.Select
                              value={line.icd101 || defaultCode}
                              onChange={(e) =>
                                handleLineChange(
                                  index,
                                  "icd101",
                                  e.target.value
                                )
                              }
                              isInvalid={!!lineErrors?.[index]?.icd101}
                            >
                              {selectedICD10s.map((icd, idx) => {
                                const codeToUse =
                                  icd.ICD10_Code || icd.ICD10_3_Code;
                                return (
                                  <option key={idx} value={codeToUse}>
                                    {icd.ICD10_3_Code} -{" "}
                                    {icd.ICD10_3_Description}
                                    {icd.ICD10_Code
                                      ? ` | ${icd.ICD10_Code} - ${icd.ICD10_Description}`
                                      : ""}
                                  </option>
                                );
                              })}
                            </Form.Select>
                          );
                        })()}
                      <Form.Control.Feedback type="invalid">
                        {lineErrors?.[index]?.icd101}
                      </Form.Control.Feedback>
                    </Col>

                    <Col md={1}>
                      <Form.Select
                        value={line.icd102 || ""}
                        onChange={(e) =>
                          handleLineChange(index, "icd102", e.target.value)
                        }
                      >
                        <option value="">Choose ICD10 Code</option>
                        {selectedICD10s.map((icd, idx) => {
                          const codeToUse = icd.ICD10_Code || icd.ICD10_3_Code;
                          return (
                            <option key={idx} value={codeToUse}>
                              {icd.ICD10_3_Code} - {icd.ICD10_3_Description}
                              {icd.ICD10_Code
                                ? ` | ${icd.ICD10_Code} - ${icd.ICD10_Description}`
                                : ""}
                            </option>
                          );
                        })}
                      </Form.Select>
                    </Col>

                    <Col md={1}>
                      <Form.Control
                        type="text"
                        value={line.tariffCode || ""}
                        onChange={(e) =>
                          handleLineChange(index, "tariffCode", e.target.value)
                        }
                        readOnly={isCompleted}
                        style={
                          isCompleted ? { backgroundColor: "#e9ecef" } : {}
                        }
                      />
                    </Col>

                    <Col md={3}>
                      <Form.Control
                        type="text"
                        value={line.description || ""}
                        onChange={(e) =>
                          handleLineChange(index, "description", e.target.value)
                        }
                        isInvalid={!!lineErrors?.[index]?.description}
                        readOnly={isCompleted}
                        style={
                          isCompleted ? { backgroundColor: "#e9ecef" } : {}
                        }
                      />
                      <Form.Control.Feedback type="invalid">
                        {lineErrors?.[index]?.description}
                      </Form.Control.Feedback>
                    </Col>

                    <Col md={1}>
                      <Form.Control
                        type="number"
                        className="me-3"
                        value={line.quantity || 1}
                        onChange={(e) =>
                          handleLineChange(index, "quantity", e.target.value)
                        }
                        readOnly={isCompleted}
                        style={
                          isCompleted ? { backgroundColor: "#e9ecef" } : {}
                        }
                        isInvalid={!!lineErrors?.[index]?.quantity}
                      />
                      <Form.Control.Feedback type="invalid">
                        {lineErrors?.[index]?.quantity}
                      </Form.Control.Feedback>
                    </Col>

                    <Col md={1}>
  <Form.Group className="d-flex align-items-center">
    {/* Currency prefix */}
    <span className="me-2">R</span>

    <Form.Control
      type="text"
      className="text-end"
      value={line.rate || ""}
      readOnly={isCompleted}
      style={isCompleted ? { backgroundColor: "#e9ecef" } : {}}
      isInvalid={!!lineErrors?.[index]?.rate}

      onChange={(e) => {
        // Only allow digits and dot
        const raw = e.target.value.replace(/[^0-9.]/g, "");
        handleLineChange(index, "rate", raw);
      }}

      onBlur={(e) => {
        // Force two decimals, no commas
        const num = parseFloat(e.target.value.replace(/,/g, ""));
        const formatted = isNaN(num)
          ? "0.00"
          : num.toLocaleString("en-ZA", {
              minimumFractionDigits: 2,
              maximumFractionDigits: 2,
              useGrouping: false,  // ← ensures parseFloat still works in your totals
            });
        handleLineChange(index, "rate", formatted);
      }}
    />

    <Form.Control.Feedback type="invalid">
      {lineErrors?.[index]?.rate}
    </Form.Control.Feedback>
  </Form.Group>
</Col>

                    <Col
                      md={1}
                      className="text-center d-flex align-items-center justify-content-center"
                    >
                      <Form.Check
                        type="checkbox"
                        checked={line.privatePayment}
                        onChange={(e) =>
                          handleLineChange(
                            index,
                            "privatePayment",
                            e.target.checked
                          )
                        }
                      />
                    </Col>

                    <Col md={1} className="text-start">
                      <Button
                        variant=""
                        className="text-danger"
                        size="sm"
                        onClick={() => handleRemoveLine(index)}
                      >
                        <i className="fa fa-trash"></i>
                      </Button>
                    </Col>
                  </Row>
                )}
              </div>
            ))}

            {/* Total */}
            <hr />
            <Row className="mt-3">
              <Col md={{ span: 4, offset: 6 }} className="text-end mt-1">
                Total Medical Aid:
              </Col>
              <Col md={2}>
                <Form.Control
                  type="text"
                  readOnly
                  className="text-end"
                  value={new Intl.NumberFormat("en-ZA", {
                    style: "currency",
                    currency: "ZAR",
                  }).format(totalMedicalAidAmount)}
                />
              </Col>
            </Row>
            <Row className="mt-1">
              <Col md={{ span: 4, offset: 6 }} className="text-end mt-1">
                Total Patient:
              </Col>
              <Col md={2}>
                <Form.Control
                  type="text"
                  readOnly
                  className="text-end"
                  value={new Intl.NumberFormat("en-ZA", {
                    style: "currency",
                    currency: "ZAR",
                  }).format(totalPatientAmount)}
                />
              </Col>
            </Row>
            <Row className="mt-1">
              <Col
                md={{ span: 4, offset: 6 }}
                className="text-end fw-bold mt-1"
              >
                Total:
              </Col>
              <Col md={2}>
                <Form.Control
                  type="text"
                  readOnly
                  className="text-end"
                  value={new Intl.NumberFormat("en-ZA", {
                    style: "currency",
                    currency: "ZAR",
                  }).format(totalAmount)}
                />
              </Col>
            </Row>

            {/* Submit Buttons on one line */}
            <div className="d-flex justify-content-end mt-4">
              {userRole.includes("Finance") && (
                <Button variant="primary" onClick={handlePost} className="me-2">
                  Complete & Post Invoice
                </Button>
              )}
              <Button variant="primary" onClick={handleSubmit}>
                Complete & Save Invoice
              </Button>
            </div>
          </Form>
        </Modal.Body>
      </Modal>
    </>
  );
}

export default CompleteAppointmentModal;
